/*
 * @Description  : 订单管理
 * @Author       : git config user.sname
 * @Date         : 2025-12-27 14:00:46
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-04-09 13:47:59
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\order-management.js
 */
import request from "../request.js";

// 订单列表分页   ====孙强
export const getOrderPage = function (data) {
    return request({
        url: `/bmPayment/getOrderPage`,
        method: 'post',
        data
    })
}
// 订单列表 - 删除或取消订单   ====孙强
export const delOrCancelOrder = function (data) {
    return request({
        url: `/bmPayment/delOrCancelOrder`,
        method: 'post',
        data
    })
}
// 订单列表 - 订单详情   ====孙强(转 朱新宇)
export const getOrderDetail = function (data) {
    return request({
        url: `/bmPayment/getOrderDetail`,
        method: 'post',
        data
    })
}
// 订单列表 - 订单商品快照分页   ====孙强(转 朱新宇)
export const selectOrderGoodsPage = function (data) {
    return request({
        url: `/bmPayment/selectOrderGoodsPage`,
        method: 'post',
        data
    })
}
// 订单列表 - 订单分账分页   ====孙强(转 朱新宇)
export const selectOrderSubPage = function (data) {
    return request({
        url: `/bmPayment/selectOrderSubPage`,
        method: 'post',
        data
    })
}
// 订单列表 - 订单操作记录分页   ====孙强(转 朱新宇)
export const selectOrderOperatePage = function (data) {
    return request({
        url: `/bmPayment/selectOrderOperatePage`,
        method: 'post',
        data
    })
}

// 分账明细分页列表-yefan
export const getPageSubs = function (data) {
	return request({
		url: `/ngsOrder/getPageSubs`,
		method: 'post',
		data
	})
}

//商品列表-详情   ====孙强(转 朱新宇)
export const getOrderGoodsDetail = function (data) {
    return request({
        url: `/bmPayment/getOrderGoodsDetail`,
        method: 'post',
        data
    })
}

// 订单列表 -- 手动退款   ====叶凡
export const manualRefund = function (data) {
    return request({
        url: `/bmPayment/manualRefund`,
        method: 'post',
        data
    })
}
